import application from 'application/application';

import moment from 'moment';

const DEFINITIONS = {
	autoApply: true,
	autoUpdateInput: false,
	locale: {
		format: 'DD/MM/YYYY',
		separator: ' até ',
		applyLabel: 'Apply',
		cancelLabel: 'Cancel',
		fromLabel: 'From',
		toLabel: 'To',
		customRangeLabel: 'Custom',
		weekLabel: 'W',
		daysOfWeek: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
		monthNames: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro'
		],
		firstDay: 1
	}
};

application.directive('ngDatePickerRange', [
	'$rootScope',
	'$stateParams',
	($rootScope, $stateParams) => ({
		link(scope, element, attrs) {
			// variavel para  guardar o id do input
			let id = attrs.$attr.id !== 'id' ? attrs.$attr.id : attrs.id;

			if (
				($rootScope.pageSelected == 'Int' && !$stateParams.periodo) ||
				$rootScope.pageSelected == 'Key' ||
				($rootScope.pageSelected == 'pastaPubli' && $stateParams.folderType)
			) {
				const dataInicial = new Date();

				const I = new Date(
					dataInicial.getFullYear(),
					dataInicial.getMonth(),
					dataInicial.getDate() - 14
				);

				if (!$stateParams.dataInicial) $stateParams.dataInicial = I;

				const VI = moment(I).format('DD/MM/YYYY');
				const CI = moment($stateParams.dataInicial).format('DD/MM/YYYY');
				const F = new Date(
					dataInicial.getFullYear(),
					dataInicial.getMonth(),
					dataInicial.getDate()
				);

				if (!$stateParams.dataFinal) $stateParams.dataFinal = F;

				const VF = moment(F).format('DD/MM/YYYY');
				const CF = moment($stateParams.dataFinal).format('DD/MM/YYYY');

				if (VI === CI && VF === CF) $rootScope.periodsFolderType = true;
				else $rootScope.periodsFolderType = false;
			}

			$rootScope.dateMovements = [];

			scope.dateArr = [];

			if (
				$rootScope.pageSelected == 'Key' ||
				$rootScope.pageSelected == 'pastaPubli'
			)
				$rootScope.periodsFolderTypeSelected = true;

			if (!$stateParams.dataInicial) $rootScope.dataSelecionada = false;
			else $rootScope.dataSelecionada = true;

			if (
				$stateParams.dataInicial &&
				($rootScope.pageSelected == 'Key' ||
					$rootScope.pageSelected == 'pastaPubli') &&
				$rootScope.periodsFolderType != false
			) {
				$rootScope.periodsFolderType = true;
				$rootScope.periodsFolderTypeSelected = false;
			} else if (
				($rootScope.pageSelected == 'Key' ||
					$rootScope.pageSelected == 'pastaPubli') &&
				$rootScope.dataSelecionada &&
				!$rootScope.periodsFolderType
			)
				$rootScope.periodsFolderTypeSelected = true;

			$(function() {
				if (id && id !== 'data-id') {
					$(`#${id}`).daterangepicker(
						{
							...DEFINITIONS
						},
						function(start, end) {
							scope.dateArr[0] = start.format();

							scope.dateArr[1] = end.format();

							$rootScope.dataSelecionada = true;

							if (
								$rootScope.pageSelected == 'Key' ||
								$rootScope.pageSelected == 'pastaPubli'
							) {
								$stateParams.periodsFolderTypeSelected = true;
								$rootScope.periodsFolderType = false;
								localStorage.setItem('__allowFilters__', true);
							}

							$rootScope.dateMovements[0] = start.format();
							$rootScope.dateMovements[1] = end.format();
						}
					);
				}

				let dataInicial, dataInicialFormat, dataFinal, dataFinalFormat;

				if ($stateParams.periodo) {
					const inicial = moment($stateParams.periodo.split('/')[0]).format(
						'YYYY-MM-DDT00:00:00'
					);
					const final = moment($stateParams.periodo.split('/')[1]).format(
						'YYYY-MM-DDT23:59:59'
					);

					dataInicial = new Date(inicial);

					dataInicialFormat = new Date(
						dataInicial.getFullYear(),
						dataInicial.getMonth(),
						dataInicial.getDate()
					);

					dataFinal = new Date(final);

					dataFinalFormat = new Date(
						dataFinal.getFullYear(),
						dataFinal.getMonth(),
						dataFinal.getDate()
					);

					$('#' + id).val(
						moment(inicial).format('DD/MM/YYYY') +
							' até ' +
							moment(final).format('DD/MM/YYYY')
					);
				}

				if ($stateParams.dataInicial) {
					dataInicial = new Date($stateParams.dataInicial);

					dataInicialFormat = new Date(
						dataInicial.getFullYear(),
						dataInicial.getMonth(),
						dataInicial.getDate()
					);
				}

				if ($stateParams.dataFinal) {
					dataFinal = new Date($stateParams.dataFinal);

					dataFinalFormat = new Date(
						dataFinal.getFullYear(),
						dataFinal.getMonth(),
						dataFinal.getDate()
					);
				}

				if ($(element)) {
					$(element)
						.data('daterangepicker')
						.setStartDate(dataInicialFormat);

					$(element)
						.data('daterangepicker')
						.setEndDate(dataFinalFormat);
				}

				if (
					$rootScope.pageSelected == 'todas' &&
					$stateParams.dataInicial &&
					$stateParams.dataInicial
				) {
					$rootScope.periodsFolderType = false;
				}

				if ($stateParams.dataInicial && !$rootScope.periodsFolderType) {
					$rootScope.dateMovements[0] = $stateParams.dataInicial;
					$rootScope.dateMovements[1] = $stateParams.dataFinal;

					$('#' + id).val(
						moment($stateParams.dataInicial).format('DD/MM/YYYY') +
							' até ' +
							moment($stateParams.dataFinal).format('DD/MM/YYYY')
					);
				} else if (
					($rootScope.pageSelected == 'Int' && !$stateParams.periodo) ||
					($stateParams.dataInicial &&
						($rootScope.pageSelected == 'Key' ||
							$rootScope.pageSelected == 'pastaPubli') &&
						$rootScope.periodsFolderType)
				) {
					$('#' + id).val('Período - últimos 15 dias');
					$rootScope.periodsFolderTypeSelected = false;
				}

				//Atribui formatação na data quando selecionada
				$(element).on('apply.daterangepicker', function(ev, picker) {
					$rootScope.periodsSubpoena = true;

					$(this).val(
						picker.startDate.format('DD/MM/YYYY') +
							' até ' +
							picker.endDate.format('DD/MM/YYYY')
					);

					scope.$apply();
				});

				$(`#${id}`).on('cancel.daterangepicker', function() {
					$(this).val('');
				});
			});
		}
	})
]);
